module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAaCAMAAACw0Z1uAAAAM1BMVEVMaXHR0tTR0tTR0tTR0tTR0tTR0tTR0tTR0tTR0tTR0tTR0tTR0tTR0tTR0tTR0tTR0tQCe1u4AAAAEHRSTlMA8BBwoNAgQMCAYOAwkFCwwqDCmQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAFpJREFUGBnFzksOwCAIBFC0Koz9cf/TNoImNWnSdFVWvAXDkE+sp4gIXNuqNmIqQe9MOjFMLLbmylwa2dhTB/mJu0j2W6sxQnvyJy6Ad0wAjpe/P7IVBSIR0QX82gxQ/O/fWQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/f.png
// module id = 70
// module chunks = 0